// // Deals.jsx
// import React, { useContext, useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Context } from '../../index';
// import { updatedeals } from '../../services/StudentService';
// import { toast } from 'react-toastify';
// import carGif from '../../../src/images/car.gif';
// import useIsMobile from "../../utils/useIsMobile";
//
// const Deals = () => {
//     const navigate = useNavigate();
//     const { store } = useContext(Context);
//     const [isUpdating, setIsUpdating] = useState(false);
//     const isMounted = useRef(true);
//
//     useEffect(() => {
//         return () => {
//             isMounted.current = false; // Cleanup on unmount
//         };
//     }, []);
//
//     const handleButtonClick = async () => {
//         setIsUpdating(true); // Set loading state
//         const emailToUpdate = store.user.email; // Get the email string
//
//         try {
//             // Pass the email string directly to updatedeals
//             await updatedeals(emailToUpdate); // <-- THIS IS THE CRITICAL CHANGE
//
//             // If the component is still mounted and the API call was successful
//             if (isMounted.current) {
//                 toast.success('Toppen! Vi hör av oss.'); // Show success toast
//                 // Add a small delay for the toast to be visible before navigation
//                 setTimeout(() => {
//                     if (isMounted.current) { // Check mount status again before navigating
//                         navigate('/login'); // Redirect
//                     }
//                 }, 500);
//             }
//         } catch (error) {
//             if (isMounted.current) {
//                 console.error('Deals Component: Error updating deals:', error);
//                 // Try to get a more specific error message from the response
//                 const errorMessage = error.response?.data?.message || error.message || 'Ett okänt fel uppstod.';
//                 toast.error(`Ett fel uppstod: ${errorMessage}`);
//             }
//         } finally {
//             // Always reset the loading state, but only if component is still mounted
//             if (isMounted.current) {
//                 setIsUpdating(false);
//             }
//         }
//     };
//
//     const isMobile = useIsMobile();
//
//     return (
//         <div className='card center mt-64' style={{ maxWidth: 360, minHeight: 300 }}>
//             <div className='m-16'>
//                 <h3 className='p-16 pb-32'>
//                     Vi jobbar på det! Snart har du en lista av exklusiva deals redo.
//                 </h3>
//                 <br />
//                 <img src={carGif} alt="Car animation" width="270" height="180" style={{ borderRadius: '9px' }} />
//                 <h3 className='p-16 pb-32'>
//                     Meddela mig när allt är klart
//                 </h3>
//                 <button
//                     onClick={handleButtonClick}
//                     style={{ maxWidth: 400 }}
//                     className={`${isMobile ? 'ghostbuttonM mb-32' : 'ghostbutton mb-32'}`}
//                     disabled={isUpdating}
//                 >
//                     {isUpdating ? 'Uppdaterar...' : 'Ja tack!'}
//                 </button>
//             </div>
//         </div>
//     );
// };
//
// export default Deals;


import React, { useContext, useState, useEffect } from 'react'; // Removed useEffect, useRef
import { useNavigate } from 'react-router-dom';
import { Context } from '../../index';
import { updatedeals } from '../../services/StudentService';
import { toast } from 'react-toastify';
import carGif from '../../../src/images/car.gif';
import useIsMobile from "../../utils/useIsMobile";

const Deals = () => {
    const navigate = useNavigate();
    const { store } = useContext(Context);
    const [isUpdating, setIsUpdating] = useState(false);

    // Removed useEffect and isMounted ref entirely

    const handleButtonClick = async () => {
        setIsUpdating(true); // Set loading state
        const emailToUpdate = store.user.email; // Get the email string

        try {
            // Pass the email string directly to updatedeals
            await updatedeals(emailToUpdate);
            // If the API call was successful, show toast and navigate
            toast.success('Toppen! Vi hör av oss.'); // Show success toast

            // Add a small delay for the toast to be visible before navigation
            setTimeout(() => {
                navigate('/login'); // Redirect
            }, 1000);

        } catch (error) {
            console.error('Deals Component: Error updating deals:', error);
            // Try to get a more specific error message from the response
            const errorMessage = error.response?.data?.message || error.message || 'Ett fel uppstod.';
            toast.error(`Ett fel uppstod: ${errorMessage}`);
        } finally {
            if (isMounted.current) {
                setIsUpdating(false);
            }
        }
    };

    // Use ref to track mount status
    const isMounted = React.useRef(true);
    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    const isMobile = useIsMobile();

    return (
        <div className='card center mt-64' style={{ maxWidth: 360, minHeight: 300 }}>
            <div className='m-16'>
                <h3 className='p-16 pb-32'>
                    Vi jobbar på det! Snart har du en lista av exklusiva deals redo.
                </h3>
                <br />
                <img src={carGif} alt="Car animation" width="270" height="180" style={{ borderRadius: '9px' }} />
                <h3 className='p-16 pb-32'>
                    Meddela mig när allt är klart
                </h3>
                <button
                    onClick={handleButtonClick}
                    style={{ maxWidth: 400 }}
                    className={`${isMobile ? 'ghostbuttonM mb-32' : 'ghostbutton mb-32'}`}
                    disabled={isUpdating}
                >
                    {isUpdating ? 'Uppdaterar...' : 'Ja tack!'}
                </button>
            </div>
        </div>
    );
};

export default Deals;